export default {
  init() {
    $('.showDescription').on('click', function () {
      $(this).siblings('.hidden').fadeIn()
      $(this).remove()
    })
    $('[data-modal="member"]').on('click', function() {
      if ($('#modal').html()) {
        return
      }
      $('body').addClass('noscroll')
      const html = `<div class="wrap">${$(this).html()}</div>`
      $('#modal').html(html).addClass('active')
    })
    $('#carousel').slick({
      autoplay: true,
      autoplaySpeed: 10000,
      speed: 800,
      infinite: true,
      dots: false,
      arrows: false,
      draggable: false,
      fade: true,
      pauseOnHover: false,
      cssEase: 'ease-in-out'
    })
  },
  beforeLeave() {
    $('.showDescription').off()
    $('[data-modal="member"]').off()
    // カルーセル破棄
    if ($('#carousel').hasClass('slick-initialized')) {
      $('#carousel').slick('destroy');
    }
  }
};
